import { createSlice } from '@reduxjs/toolkit';
import AdminApi from "../../../api/AdminApi";
import { showNotification } from "./notification";

type State = {
    data: Array<Object>,
    isLoading: boolean,
    error: Object | null
}

const initialState = {
    data: [],
    isLoading: false,
    error: null,
}

const brands = createSlice({
    name: 'bigscreenSettings',
    initialState,
    reducers: {
        fetchBigscreenSettingsStart: (state: State) => {
            state.isLoading = true;
            state.error = null;
        },
        fetchBigscreenSettingsSuccess: (state: State, action) => {
            if (action.payload && Array.isArray(action.payload)) {
                state.data = action.payload;
            }
            state.isLoading = false;
            state.error = false;
        },
        fetchBigscreenSettingsFailed: (state: State, action) => {
            state.isLoading = false;
            state.error = action.payload
        }
    }
});

// Actions
export const {
    fetchBigscreenSettingsStart,
    fetchBigscreenSettingsSuccess,
    fetchBigscreenSettingsFailed
} = brands.actions;

export default brands.reducer;

// Thunk
export const fetchBigscreenSettings = () => async (dispatch: Function) => {
    try {
        dispatch(fetchBigscreenSettingsStart());
        const api = new AdminApi();
        const result = await api.getBigscreenSettings();
        dispatch(fetchBigscreenSettingsSuccess(result));
    } catch (err: any) {
        dispatch(fetchBigscreenSettingsFailed(err));
        dispatch(showNotification('error', err.message));
    }
}
